<script>
import {ref} from "vue";
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import 'primeicons/primeicons.css'
import axios from "axios";
import Swal from "sweetalert2";
import AutoComplete from 'primevue/autocomplete';
import { useGradeStore } from '@/stores/useGradeStore.js';

export default {
  name: 'QuickSearch',
  components: {
    Dialog,
    Dropdown,
    AutoComplete
  },
  data() {
    return {
      visible: ref(false),
      selected_level: null,
      gender_list: [
        {
          id: 1,
          title: "ولد",
        },
        {
          id: 2,
          title: "بنت",
        },
      ],
      gender: "",
      student_phone: "",
      // grades loaded from store in computed
      reservations: [],
      user: {},
      student_name: "",
      filteredUsers: [],
    }
  },
  computed: {
    gradeStore() { return useGradeStore(); },
    levels() {
      const all = this.gradeStore.allGrades.length ? this.gradeStore.allGrades : this.gradeStore.activeGrades;
      return all.map(g => ({ name: g.name, id: g.id }));
    },
  },
  methods: {
    toEnglishDigits(str) {
      if (!str) return str;
      return str.replace(/[٠-٩]/g, d => '٠١٢٣٤٥٦٧٨٩'.indexOf(d));
    },
    fetchReservation(page = 1) {
      const formData = new FormData();
      formData.append('status', 1);
      formData.append('order_by_name', 1);

      if (this.selected_level) {
        formData.append('academic_year_id', this.selected_level.id);
      }
      if (this.gender) {
        formData.append('gender', this.gender.id);
      }

      axios.defaults.headers.common["per_page"] = 10000000;
      axios
          .post(`/all_reservations?page=${page}`, formData)
          .then((response) => {
            this.reservations = response.data.data.data;
            this.paggination = response.data.data.meta.total;
          })
          .catch((error) => {
            this.reservations = {};
          });
    },
    userSelected() {
      if (this.user) {
        this.student_phone = this.user.student_phone;
        this.student_name = this.user.name;
      } else {
        this.student_phone = "";
      }
    },
    getUserLabel(option) {
      // Customize as needed, e.g. show name and phone
      return `${option.name} - ${option.student_phone}`;
    },
    sendForm() {
      const formData = new FormData();
      if(this.user) {
        formData.append('user_id', this.user.id);
      }
      if (this.student_phone) {
        formData.append('student_phone', this.toEnglishDigits(this.student_phone));
      }
      if (this.student_name) {
        formData.append('student_name', this.student_name);
      }

      this.formSending = true;

      axios
          .post('/update_user_dashboard', formData)
          .then((response) => {
            this.formSending = false;
            Swal.fire({
              position: "center",
              icon: "success",
              title: `تم تحديث بيانات الطالب ${this.user.name} بنجاح`,
              timer: 1000,
              showConfirmButton: false,
            });
            this.user = "";
            this.student_phone = ""
          })
          .catch((error) => {
            this.formSending = false;
            Swal.fire({
              position: "center",
              icon: "error",
              title: error.response.data.message,
              showConfirmButton: false,
            });
          });
    },
    search(event) {
      const query = event.query.toLowerCase();
      this.filteredUsers = this.reservations.filter(user =>
          user.name.toLowerCase().includes(query)
      );
    },
  },
  async mounted() {
    if (!this.gradeStore.allGrades.length) await this.gradeStore.fetchAllGrades();
    if (!this.gradeStore.activeGrades.length) await this.gradeStore.fetchActiveGrades();
  },
};
</script>

<template>
  <div class="quick-search" v-if="$store.getters['isAuthenticated']">
    <button type="button"
            class="btn PrimaryButton"
            :tooltip="'تعديل رقم الطالب'"
            flow="up"
            @click="visible = true">
      <i class="pi pi-pen-to-square"></i>
    </button>
    <Dialog v-model:visible="visible" modal header="تعديل رقم الطالب"
            :breakpoints="{ '1920px': '25vw', '1440px': '50vw', '991px': '95vw' }">
      <div class="row">
        <div class="col-12 mb-3">
          <Dropdown v-model="selected_level" :options="levels" showClear optionLabel="name" placeholder="اختر الصف"
                    class="w-100" @change="fetchReservation"/>
        </div>
        <div class="col-12 mb-3">
          <Dropdown v-model="gender" :options="gender_list" showClear optionLabel="title" placeholder="الجنس"
                    class="w-100" @change="fetchReservation"/>
        </div>
        <div class="col-12 mb-3">
<!--          <Dropdown v-model="user" :options="reservations" filter showClear :optionLabel="getUserLabel" placeholder="اختر الطالب"-->
<!--                    class="w-100" @change="userSelected"/>-->

          <AutoComplete
              v-model="user"
              :suggestions="filteredUsers"
              :optionLabel="getUserLabel"
              placeholder="اختر الطالب"
              class="w-100"
              @complete="search"
              @change="userSelected"
          />
        </div>
        <div class="col-12 mb-3">
          <input type="text" class="w-100 form-control" name="student_name" id="student_name" placeholder="اسم الطالب"
                 v-model="student_name"/>
        </div>
        <div class="col-12 mb-3">
          <input type="text" class="w-100 form-control" name="student_phone" id="student_phone" placeholder="رقم الطالب"
                 v-model="student_phone"/>
        </div>
        <div class="col-12">
          <button type="button" class="btn PrimaryButton w-100" @click="sendForm">حفظ</button>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<style scoped>

</style>